import { Component, Input } from '@angular/core';
import { environment } from 'src/environments/local/environment';
import { Countries } from 'src/app/app.consts';
import { Router } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent {
  isFinland = environment.country === Countries.FINLAND;
  isSweden = environment.country === Countries.SWEDEN;
  faqLink = environment.faq;
  isChatInitialized: boolean = false;

  @Input() outsideCard = false;

  constructor(private router: Router) {
    if (this.router.url.includes('partner')) {
      this.faqLink = environment.faqPartner;
    }
  }

  openChat(): void {
    // If hsScriptId exists and chat is not initilized - add hs script
    if (environment.hsScriptId && !this.isChatInitialized) {
      let script = document.createElement('script');
      script.src = `//js.hs-scripts.com/${environment.hsScriptId}.js`;
      document.getElementsByTagName('head')[0].appendChild(script);
      this.isChatInitialized = true;
    }

    // Small delay and try/catch to make sure we don't try to open widget when it doesn't exist
    setTimeout(() => {
      try {
        if (this.isChatInitialized) HubSpotConversations.widget.open();
      } catch { }
    }, 400);
  }
}
